import service from '@/store/services/workshop/part_dealer-service';

const state = {
  list: {},
  part_dealer: {},
  meta: {}
};

const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, part_dealer) => {
    state.part_dealer = part_dealer;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  }
};

const actions = {
  list({commit, dispatch}, params) {
    return service.list(params)
      .then(({list, meta}) => {
        commit('SET_LIST', list);
        commit('SET_META', meta);
      });
  },

  get({commit, dispatch}, params) {
    return service.get(params)
      .then((part_dealer) => { commit('SET_RESOURCE', part_dealer); });
  },

  add({commit, dispatch}, params) {
    return service.add(params)
      .then((part_dealer) => { commit('SET_RESOURCE', part_dealer); });
  },

  update({commit, dispatch}, params) {
    return service.update(params)
      .then((part_dealer) => { commit('SET_RESOURCE', part_dealer); });
  },

  destroy({commit, dispatch}, params) {
    return service.destroy(params);
  },
  last_no({commit, dispatch}, params) {
    return service.last_no(params)
      .then((part_dealer) => { commit('SET_RESOURCE', part_dealer); });
  }
};

const getters = {
  list: state => state.list,
  listTotal: state => state.meta.page.total,
  part_dealer: state => state.part_dealer,
};
 
const part_dealer = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default part_dealer;
